import axios from '@/libs/api.request'
// 首页一级分类数据 
export const xxShouYeYiJi = data => {
  return axios.request({
    url: 'xxShouYeYiJi',
    data: data,
    method: 'post'
  })
}
// 友情链接
export const xxShouYeLinks = data => {
  return axios.request({
    url: 'xxShouYeLinks',
    data: data,
    method: 'post'
  })
}
// 首页文章分类
export const xxShouYeArticle = data => {
  return axios.request({
    url: 'xxShouYeArticle',
    data: data,
    method: 'post'
  })
}
// 首页轮播图
export const xxShouYeLunBo = data => {
  return axios.request({
    url: 'xxShouYeLunBo',
    data: data,
    method: 'post'
  })
}
// 一级分类下的二级分类
export const xxYiJiLanMu = data => {
  return axios.request({
    url: 'xxYiJiLanMu',
    data: data,
    method: 'post'
  })
}
// 二级栏目页面展示
export const xxErJiLanMu = data => {
  return axios.request({
    url: 'xxErJiLanMu',
    data: data,
    method: 'post'
  })
}
// 快速通道
export const xxFastChannel = data => {
  return axios.request({
    url: 'xxFastChannel',
    data: data,
    method: 'post'
  })
}
// 文章详情
export const xxArticleDetail = data => {
  return axios.request({
    url: 'xxArticleDetail',
    data: data,
    method: 'post'
  })
}
// 顶部和底部数据
export const xxShouYeOther = data => {
  return axios.request({
    url: 'xxShouYeOther',
    data: data,
    method: 'post'
  })
}
// 首页搜索
export const xxShouYeSelect = data => {
  return axios.request({
    url: 'xxShouYeSelect',
    data: data,
    method: 'post'
  })
}
// 热点推荐列表
export const redianArticleList = data => {
  return axios.request({
    url: 'redianArticleList',
    data: data,
    method: 'post'
  })
}
// 前台学生信息查询
export const net_QiantaiStudentQuery = data => {
  return axios.request({
    url: 'net_QiantaiStudentQuery',
    data: data,
    method: 'post'
  })
}
// 前台高一录取信息查询
export const net_QiantaiGaoyiQuery = data => {
  return axios.request({
    url: 'net_QiantaiGaoyiQuery',
    data: data,
    method: 'post'
  })
}
// 验证
export const yanzhengimg = data => {
  return axios.request({
    url: 'yanzhengimg',
    data: data,
    method: 'post'
  })
}
// 校友首页信息
export const net_XiaoyouShouyeInfo = (data) => {
  return axios.request({
    url: 'net_XiaoyouShouyeInfo',
    method: 'post',
    data: data
  })
}
// 后台校友信息详情
export const net_HoutaiXiaoyouDetail = (data) => {
  return axios.request({
    url: 'net_HoutaiXiaoyouDetail',
    method: 'post',
    data: data
  })
}
// 校友新增/编辑
export const net_XiaoyouAddOrEdit = (data) => {
  return axios.request({
    url: 'net_XiaoyouAddOrEdit',
    method: 'post',
    data: data
  })
}
// 前台校友信息查询
export const net_QiantaiXiaoyouQuery = (data) => {
  return axios.request({
    url: 'net_QiantaiXiaoyouQuery',
    method: 'post',
    data: data
  })
}
// 前台学生信息完善查询
export const net_ws_QiantaiStudentQuery = (data) => {
  return axios.request({
    url: 'net_ws_QiantaiStudentQuery',
    method: 'post',
    data: data
  })
}
// 学生信息完善详情
export const net_ws_HoutaiStudentDetail = (data) => {
  return axios.request({
    url: 'net_ws_HoutaiStudentDetail',
    method: 'post',
    data: data
  })
}
// 保存学生信息完善
export const net_ws_StudentInfoEdit = (data) => {
  return axios.request({
    url: 'net_ws_StudentInfoEdit',
    method: 'post',
    data: data
  })
}
